__turbopack_context__.v({
  "className": "lato_cbab3b9a-module__aginHW__className",
});
